var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo, useState } from 'react';
import { C } from '#integrations';
import { TabListContext } from '../../context/TabListContext';
import { TabsTestIdFactory } from '../../interactions';
import { TAB_KINDS, TAB_ORIENTATIONS, TAB_SIZES } from '../../Tabs.constants';
import styles from './TabList.module.css';
const ORIENTATION_CLASS_MAP = {
    horizontal: styles.Horizontal,
    vertical: styles.Vertical,
};
const KIND_CLASS_MAP = {
    default: styles.Default,
    ghost: styles.Ghost,
};
export const TabList = ({ children, 'data-testid': testId, isFullWidth = false, kind = TAB_KINDS.DEFAULT, orientation = TAB_ORIENTATIONS.HORIZONTAL, tabSize = TAB_SIZES.DEFAULT, }) => {
    _react_refresh_temp_2();
    const [registeredTabs, setRegisteredTabs] = useState(new Set());
    const registerTab = useCallback((tabId) => {
        setRegisteredTabs((prevRegisteredTabs) => new Set([...prevRegisteredTabs, tabId]));
    }, []);
    const unregisterTab = useCallback((tabId) => {
        setRegisteredTabs((prevRegisteredTabs) => {
            const nextRegisteredTabs = new Set(prevRegisteredTabs);
            nextRegisteredTabs.delete(tabId);
            return nextRegisteredTabs;
        });
    }, []);
    // Shared during render so Tab children style themselves on the same pass
    const providerValue = useMemo(() => ({
        isFullWidth,
        kind,
        orientation,
        registeredTabs,
        registerTab,
        tabSize,
        unregisterTab,
    }), [
        isFullWidth,
        kind,
        orientation,
        registeredTabs,
        registerTab,
        tabSize,
        unregisterTab,
    ]);
    return (_jsx(TabListContext.Provider, { value: providerValue, children: _jsx("div", { "aria-orientation": orientation, className: C(styles.Container, ORIENTATION_CLASS_MAP[orientation], KIND_CLASS_MAP[kind], isFullWidth && styles.FullWidth), "data-testid": TabsTestIdFactory.getTabListTestId(testId), role: "tablist", children: children }) }));
};
_react_refresh_temp_1 = TabList;
$RefreshReg$(_react_refresh_temp_1, "TabList");
_react_refresh_temp_2(TabList, "+Q5lTKyeLXk0hwtS+VN2msBEKlg=");
